/**
 * Trademark / non-affiliation copy for the descriptive-use SEO surfaces (#353, D353.1).
 *
 * The Jeopardy-relevance SEO work (issue #353) relaxes the absolute "no third-party marks"
 * rule (FR-9.11 / SEO_KEYWORDS D241.9) to permit **descriptive nominative use** of the
 * game-format term — "Jeopardy-style" in indexable copy and bare "Jeopardy" in the four
 * product-intent landing slugs. That permission is conditional on every page carrying a
 * **non-affiliation disclaimer**, so these two strings are the single source both the FAQ
 * ({@link ./route-seo}.FAQ_ITEMS) and the landing template ({@link ../pages/SeoLanding})
 * render. The product name reads from {@link BRAND_NAME} (FR-9.11) — never hard-coded.
 */

import { BRAND_NAME } from '../ui/brand';

/**
 * The explicit affiliation clarification (issue §12). Rendered verbatim as the visible
 * answer to "Is {brand} affiliated with Jeopardy?" AND baked into the `FAQPage` JSON-LD, so
 * the structured data matches the on-page text.
 */
export const AFFILIATION_ANSWER = `No. ${BRAND_NAME} is an independent trivia game and is not affiliated with or endorsed by Jeopardy Productions, Inc.`;

/**
 * The small muted footnote shown at the bottom of every descriptive-use SEO landing page
 * (issue §12/§9, D353.8). Spells out that "Jeopardy" is a third-party mark and that
 * {@link BRAND_NAME}'s use of "Jeopardy-style" is purely descriptive of the game format.
 */
export const SEO_DISCLAIMER = `"Jeopardy" is a trademark of Jeopardy Productions, Inc. ${BRAND_NAME} is an independent product and is not affiliated with, endorsed by, or sponsored by Jeopardy Productions, Inc. "Jeopardy-style" is used descriptively to indicate the game format.`;
